$(document).ready(function () {
  $(document).on('click', '.title-click-to-scroll-to-brand-info', function () {
    console.log('here1');
    if ($('.brand-info-section-to-scroll-till').length) {
      console.log('here2');
      var moveToBrandSectionTop = 150;
      if (document.documentElement.clientWidth  <= 991) {
         var moveToBrandSectionTop = 100;
      }
      $('html').animate({
          scrollTop: $('.brand-info-section-to-scroll-till').offset().top - moveToBrandSectionTop
      }, 1000);
    }
  });
});